import Main from './GovernanceProjectsMain'
import Manage from './GovernanceProjectsManage'
import ActivityManage from './ActivityManage'

export default {
  Main,
  Manage,
  ActivityManage,
}
